<template>
  <span class="scaling-svg-container">
    <svg
      data-name="Icon/Arrow Ios Up"
      xmlns="http://www.w3.org/2000/svg"
      width="14.376"
      height="7.188"
      viewBox="0 0 14.376 7.188"
      class="scaling-svg"
    >
      <path
        data-name="Icon/Icon/Arrow-ios-up"
        d="M13.349,7.188a1.022,1.022,0,0,1-.657-.238l-5.515-4.6L1.67,6.785a1.027,1.027,0,1,1-1.287-1.6L6.545.227a1.025,1.025,0,0,1,1.3.011l6.161,5.134a1.027,1.027,0,0,1-.658,1.815"
        transform="translate(0)"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ArrowUpIcon extends Vue {}
</script>

<style>
</style>
